// @ts-nocheck
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import { Field, initialize, reduxForm } from 'redux-form';
import { BLUE } from '../../_config/consts';
import * as PowerControlUnitsActions from '../../redux/actions/powerControlUnits.actions';
import * as ModalActions from '../../redux/actions/modal.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';
import CustomField from '../forms/Fields/CustomField.jsx';
import FormFlatContainer from '../forms/Elements/FormFlatContainer.jsx';
import MDButton from '../MDButton/MDButton.jsx';

function mapPcuToConsumptionFormValues(pcu) {
  const source = pcu || {};
  return {
    nominalLoadKw: source.nominalLoadKw !== undefined && source.nominalLoadKw !== null
      ? source.nominalLoadKw
      : '',
  };
}

@reduxForm({ form: 'PowerControlUnitConsumptionForm', destroyOnUnmount: false })
@connect(state => ({
  selectedPCU: state.powerControlUnits.selectedPCU,
  consumptionForm: state.form.PowerControlUnitConsumptionForm,
}))
class PowerControlUnitConsumptionView extends React.Component {
  componentDidMount() {
    const { selectedPCU } = this.props;
    this.initConsumptionForm(selectedPCU);
  }

  componentWillReceiveProps(nextProps) {
    const { selectedPCU: pcuOld } = this.props;
    const { selectedPCU: pcu } = nextProps;
    const oldId = pcuOld && pcuOld.id;
    const newId = pcu && pcu.id;
    if (newId !== oldId || pcu !== pcuOld) {
      this.initConsumptionForm(pcu);
    }
  }

  initConsumptionForm(pcu) {
    const { dispatch } = this.props;
    dispatch(initialize('PowerControlUnitConsumptionForm', mapPcuToConsumptionFormValues(pcu)));
  }

  async onSaveNominalLoad() {
    const { dispatch, selectedPCU, consumptionForm } = this.props;
    if (!selectedPCU || !selectedPCU.id) {
      return;
    }
    const raw = consumptionForm && consumptionForm.values ? consumptionForm.values.nominalLoadKw : '';
    const nominalLoadKw = raw === '' || raw === null || raw === undefined ? null : parseFloat(raw, 10);
    if (nominalLoadKw !== null && Number.isNaN(nominalLoadKw)) {
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="pcuSaveError" /></h6>),
        },
      }));
      return;
    }
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const result = await dispatch(PowerControlUnitsActions.editPowerControlUnit(
        selectedPCU.id,
        { nominalLoadKw },
      ));
      dispatch(PowerControlUnitsActions.selectPowerControlUnit(result));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="pcuSaveSuccess" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="pcuSaveError" /></h6>),
        },
      }));
    } finally {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  render() {
    const { selectedPCU } = this.props;
    const canSave = selectedPCU && selectedPCU.id;

    return (
      <div>
        <FormFlatContainer title="consumptionSettings" subtitle="consumptionSettingsDescription" containerStyle={{ marginRight: 10, marginBottom: 100 }}>
          <div style={{ marginTop: 10 }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', flexWrap: 'wrap', gap: 10 }}>
              <Entity
                componentClass={Field}
                name="nominalLoadKw"
                type="number"
                componentAttribute="placeholder"
                entity="insertNominalLoad"
                title={<Entity entity="nominalLoad" />}
                component={CustomField}
                containerStyle={{ width: 200, marginBottom: 0 }}
              />
              {canSave && (
                <MDButton
                  title={<Entity entity="save" />}
                  backgroundColor={BLUE}
                  containerStyle={{ minWidth: 100, marginBottom: 0 }}
                  style={{ height: 40, borderRadius: 0 }}
                  onClick={() => this.onSaveNominalLoad()}
                />
              )}
            </div>
            <div style={{ marginTop: 8, fontSize: 13, color: '#666' }}>
              <Entity entity="nominalLoadDescription" />
            </div>
          </div>
        </FormFlatContainer>
      </div>
    );
  }
}

export default PowerControlUnitConsumptionView;
